import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Redirect from './pages/Redirect';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  const handleLogin = (newToken) => {
    setToken(newToken);
  };

  const handleLogout = () => {
    setToken(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Redirect />} />
        <Route 
          path="/admin/login" 
          element={token ? <Navigate to="/admin" /> : <Login onLogin={handleLogin} />} 
        />
        <Route 
          path="/admin" 
          element={token ? <Dashboard token={token} onLogout={handleLogout} /> : <Navigate to="/admin/login" />} 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
